// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"68":"d76f1f6b77f8bbd7","320":"b9b5520e99912e7b","817":"4f4eb4d76ef09d35","991":"44cf2ed7b510a051"}[chunkId] + ".js";
};